import { render, staticRenderFns } from "./couponsList.vue?vue&type=template&id=27974972&scoped=true"
import script from "./couponsList.vue?vue&type=script&lang=js"
export * from "./couponsList.vue?vue&type=script&lang=js"
import style0 from "./couponsList.vue?vue&type=style&index=0&id=27974972&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27974972",
  null
  
)

export default component.exports